import { io, type Socket } from 'socket.io-client';
import { API_BASE_URL } from '../config/api';

let socket: Socket | null = null;
let socketToken: string | null = null;

export function getChatSocket(token: string): Socket {
  // A stale socket authenticated as a different account must never be reused —
  // otherwise switching accounts keeps receiving/joining rooms under the old identity.
  if (socket && socketToken !== token) {
    socket.disconnect();
    socket = null;
  }
  socketToken = token;

  if (socket?.connected) {
    return socket;
  }
  if (socket) {
    socket.auth = { token };
    socket.connect();
    return socket;
  }

  socket = io(`${API_BASE_URL}/chat`, {
    path: '/socket.io',
    transports: ['websocket', 'polling'],
    auth: { token },
    autoConnect: true,
  });
  return socket;
}

export function disconnectChatSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
  socketToken = null;
}
